export const generateRandomKey = (length, compareUploadFiles = []) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }

    if (compareUploadFiles.find(el => el.id === result)) {
        return generateRandomKey(length, compareUploadFiles);
    }

    return result;
};
